// extracted by css-extract-rspack-plugin
export default {"cls1":"Popover-cls1_bb3","cls2":"Popover-cls2_ylT Popover-cls1_bb3","inline":"Popover-inline_cl1"};